// *************** AWS Lambda API Calls ******************
//AWS Pricing Info
export const GET_LICENSE_PRICE_INFO = "/subscribe";
//AWS Metric data
export const GET_METRIC_INFO = "/metric";

//AWS Lambda URL
export const POST_LAMBDA_LOGIN = "/cloudnova/login";
export const POST_LAMBDA_LOGINWITHMFA = "/cloudnova/loginWithMFA";
export const POST_LOGIN_OPTIONS = "/cloudnova/login/options";
export const POST_LAMBDA_LOGINVERIFYTOTP = "/cloudnova/verifyTotp";
export const POST_LAMBDA_REFRESH = "/cloudnova/refresh";
export const POST_LAMBDA_FORGET_PASSWORD = "/cloudnova/password/forgot";
export const POST_LAMBDA_RESET_FORGOT_PASSWORD = "/cloudnova/password/forgot/confirm";
export const PUT_RESET_PASSWORD = "/cloudnova/changePassword"  // Change Password
export const POST_LAMBDA_NEW_USER = "/cloudnova/user";
export const SSO_CONFIG = "/cloudnova/sso/config";
export const POST_SSO_EXCHANGE = "/cloudnova/sso/exchange";
export const GET_LAMBDA_LIST_OF_ORGS_AND_ACCOUNTS = "/cloudnova/accounts";
export const GET_LAMBDA_PROFILE_ROLE_INFO = "/cloudnova/roles";
export const GET_LAMBDA_ORGS_NAME = "/cloudnova/organization/name";
export const POST_LAMBDA_REGISTER = "/organization/register";
export const PUT_LAMBDA_REGISTER = "/cloudnova/organization/updateOrgAddress"
export const GET_LAMBDA_ACC_RULES = "/cloudnova/accounts/rule";
export const GET_LAMBDA_ALL_RULES = "/cloudnova/rule";
export const GET_LAMBDA_LICENSING = "/cloudnova/licensing";
export const GET_LAMBDA_AWS_ACCOUNT_NUMBER = "/cloudnova/awsaccountnumber";
export const POST_LAMBDA_AWS_ACCOUNT_NUMBER = "/cloudnova/awsaccountnumber";
export const POST_LAMBDA_ORG_ACCOUNT = "/cloudnova/accounts";
export const PUT_LAMBDA_EDIT_USER = "/cloudnova/user";
export const DELETE_LAMBDA_USER = "/cloudnova/user";
export const PUT_LAMBDA_RULES_MAP = "/cloudnova/rule";
export const UPDATE_LAMBDA_ORG_ACCOUNT = "/cloudnova/accounts";
export const POST_ACCOUNT_COMPLIANCE = "/cloudnova/accounts/compliance";
export const POST_REGISTER = "organization/register"
export const GET_ACCOUNT_ACTIVATION = "/userauth/resendactivate";
export const GET_REACTIVE_USER_LAMBDA = '/userauth/resendactivate';
export const PUT_VALIDATE_PROSPECTIVE_TOKEN = "/userauth/checkprospectivetoken";
export const GET_LAMBDA_RESOURCE_GROUPS = '/cloudnova/resourcegroups';
export const POST_LAMBDA_RESOURCE_GROUP = '/cloudnova/resourcegroups';
//Tableau
export const GET_TAB_TOKEN_TABLEAU_LAMBDA = "/cloudnova/tabtoken";

export const GET_RULE_REMEDIATION = "/cloudnova/ruleRemediation";

// IAC
export const GET_IAAC_METRICS = "/iacmanagementfromui/metrics";
export const GET_IAAC_FILE_HISTORY = "/iacmanagementfromui/info";
export const GET_IAAC_FILE = "/iacmanagementfromui/download";
export const GET_FILE_UPLOAD_URL = "/iacmanagementfromui/upload";
export const POST_FILE_UPLOAD = "/iacmanagementfromui/upload";
export const POST_FILE_COMMIT_DETAILS = "/iacmanagementfromui/info";
export const GET_IAAC_SUBSCRIPTION = "/cloudnova/iaacSubscription";
export const POST_IAAC_SUBSCRIPTION = "/cloudnova/iaacSubscription";
export const PUT_IAAC_SUBSCRIPTION = "/cloudnova/iaacSubscription";
export const GET_IAAC_LICENSE = "/cloudnova/iaacLicense";

// Release Notes
export const GET_RELEASE_NOTES = "cloudnova/documentation";
export const GET_RELEASE_DETAILS = "cloudnova/documentation";

// Support
export const POST_SUPPORT_EMAIL = "cloudnova/support";

export const POST_AWS_FULFILLMENT = "/aws-marketplace/register";
export const POST_AWS_ONBOARD = "/aws-marketplace/onboard";

//Enable Additional Adons/Features
export const POST_FEATURE_CONFIGURATION ="/cloudnova/feature-configuration";
export const POST_ACCOUNT_CONFIGURATION ="/cloudnova/account-configuration";

// Fetch Kibana Dashboards Url
export const FETCH_KIBANA_DASHBOARDS_URL = '/cloudnova/getdashboards';

// Fetch Billing Records
export const FETCH_BILLING_RECORDS_URL = '/cloudnova/billing';

// Tag Allocation for Cost Insight
export const COST_INSIGHT_TAG_ALLOCATION = '/cloudnova/tags';
export const COST_INSIGHT_GET_TAG_ALLOCATION_ACCOUNTS = '/cloudnova/tags/workload-attributes';

// Get Organization scoping
export const GET_ORGANIZATION_SCOPE = '/cloudnova/scope';

// Add Sub Organization
export const ORGANIZATION = "/organization/msptrial";

// Customer Management
export const POST_CUSTOMER = "/organization/customer";
export const GET_CUSTOMER_ORG_ACCOUNTS = "/cloudnova/customer-org-accounts";

// Get WAFR Questionnaire
export const GET_WAFR_QUESTIONNAIRE = "/cloudnova/wafr/questionnaire";

// Delete WAFR Questionnaire
export const DELETE_WAFR_QUESTIONNAIRE = "/cloudnova/wafr/questionnaire";

// Update WAFR Questionnaire
export const UPDATE_WAFR_QUESTIONNAIRE = "/cloudnova/wafr/questionnaire";

// Get WAFR Assessment List
export const GET_WAFR_ASSESSMENT_LIST = "/cloudnova/wafr/assesment";

// Get WAFR Workload Summary
export const GET_WAFR_SUMMARY = "/cloudnova/wafr/workload";

// Create Workload
export const POST_WAFR_ASSESSMENT = "/cloudnova/wafr/workload";

// Pre-validate WAFR Assessment
export const POST_WAFR_ASSESSMENT_PRE_VALIDATE = "/cloudnova/wafr/pre-validate";

// Run CIS / Initate Rule Engine
export const POST_CIS_SCAN = "/cloudnova/wafr/cisscan";

// GET CIS Posture
export const GET_CIS_POSTURE = "/cloudnova/wafr/posture";

// Run WAFR Automated/Trusted Advisor checks
export const POST_AUTOMATED_CHECKS = "/cloudnova/wafr/tascan";

// WAFR Issues (flagged api)
export const GET_FLAGGED_DETAILS = "/cloudnova/wafr/flagged";

// Complete Assessment
export const POST_COMPLETE_ASSESSMENT = "/cloudnova/wafr/complete";

// Get WAFR Report
export const GET_WAFR_REPORT = "/cloudnova/wafr/report";

// Get WAFR PDF Report
export const GET_WAFR_PDF_REPORT = "/cloudnova/wafr/getWafrReport";

// Get Milestone PDF Report
export const GET_MILESTONE_PDF_REPORT = "/cloudnova/wafr/getmilestoneReport";

// Get Milestone List
export const GET_MILESTONE_LIST = "/cloudnova/wafr/milestone/list";

// Get Milestone Details
export const GET_MILESTONE_DETAILS = "/cloudnova/wafr/milestone";

// POST Milestone Details
export const POST_MILESTONE_DETAILS = "/cloudnova/wafr/milestone";

// WAFR Attachments
export const WAFR_ATTACHMENTS = "/cloudnova/wafr/attachments";

// WAFR Stakeholder
export const WAFR_STAKEHOLDER = "/cloudnova/wafr/stakeholder";

// Multiple Account
export const MULTI_ACCOUNT_ORG = "/cloudnova/account-metadata";
export const MULTI_ACCOUNT_YAML = "/cloudnova/generate-yaml";
export const MULTI_ACCOUNT_EVENT_INSIGHT_YAML = "/cloudnova/generate-eventinsight-yaml";
export const GET_LAMBDA_CHECK_STACK_STATUS = '/cloudnova/stack-status';
export const GET_LAMBDA_CHECK_ACCOUNT_STATUS = '/cloudnova/accounts-status';

// Compliance Module
export const GET_COMPLIANCE_LIST = '/cloudnova/audit/compliance/compliancelist';
export const GET_COMPLIANCE_CONTROL_SECTION = '/cloudnova/audit/compliance/controlsummary';
export const GET_COMPLIANCE_CONTROLS = '/cloudnova/audit/compliance/controls';
export const GET_COMPLIANCE_RESOURCES = '/cloudnova/audit/compliance/resourcelist';
export const COMPLIANCE_WORKLOAD = '/cloudnova/audit/compliance/workload';
export const COMPLIANCE_INIATE_SCAN = '/cloudnova/audit/compliance/scan';
export const COMPLIANCE_TAGS = '/cloudnova/tags/workload-tags';
export const DOWNLOAD_COMPLIANCE_REPORT = '/cloudnova/audit/compliance/report';

// CSPM
export const GET_CSPM_CHECKS = '/cloudnova/audit/cspm/checks';
export const GET_CSPM_RESOURCES = '/cloudnova/audit/cspm/checkresources';
export const DOWNLOAD_CSPM_REPORT = '/cloudnova/audit/cspm/report'
export const GET_CSPM_COMPARE = '/cloudnova/audit/cspm/compare';
export const POST_CSPM_COMPARE_RESOURCES = '/cloudnova/audit/cspm/compare-resources';

// Margin Management
export const GET_MARGIN_RECORDS = '/cloudnova/margin';
export const POST_MARGIN_RECORD = '/cloudnova/margin';
export const PUT_MARGIN_RECORD = '/cloudnova/margin';
export const DELETE_MARGIN_RECORD = '/cloudnova/margin';
export const GET_MARGIN_SUMMARY = '/cloudnova/margin-summary';

// Billing Management
export const GET_BILLING_CUSTOMERS = '/cloudnova/billing-rules/customers';
export const GET_BILLING_RULES = '/cloudnova/billing-rules';
export const GET_CUSTOMER_BILLING_RULES = '/cloudnova/billing-rules/customers';
export const GET_CUSTOMER_METADATA = '/cloudnova/billing-rules/customers';
export const POST_BILLING_RULES = '/cloudnova/billing-rules/customers';
export const PUT_BILLING_RULE = '/cloudnova/billing-rules/customers';
export const PUT_BILLING_RULES = '/cloudnova/billing-rules/customers';
export const GET_BILLING_PROFILE = '/cloudnova/billing-rules/profile';
export const PUT_BILLING_PROFILE = '/cloudnova/billing-rules/profile';
export const POST_BILLING_PROFILE_LOGO_UPLOAD = '/cloudnova/billing-rules/profile/logo/upload-url';
export const GET_BILLING_PROFILE_LOGO_VIEW = '/cloudnova/billing-rules/profile/logo/view-url';
export const DELETE_BILLING_PROFILE_LOGO = '/cloudnova/billing-rules/profile/logo';
export const GET_CUSTOMER_INVOICES = '/cloudnova/billing-rules/customers';
export const GET_CUSTOMER_PURCHASE_ORDERS = '/cloudnova/billing-rules/customers';
export const GET_BILLING_METRICS = '/cloudnova/billing-rules/metrics';
export const OFFLINE_CUR_ACCOUNTS = '/cloudnova/offline/accounts';
export const POST_OFFLINE_CUR_ACCOUNTS = OFFLINE_CUR_ACCOUNTS;
export const GET_OFFLINE_CUR_ACCOUNTS = OFFLINE_CUR_ACCOUNTS;
export const POST_OFFLINE_CUR_UPLOAD_INIT = `${OFFLINE_CUR_ACCOUNTS}/upload/init`;
export const POST_OFFLINE_CUR_UPLOAD_COMPLETE = `${OFFLINE_CUR_ACCOUNTS}/upload/complete`;
export const POST_OFFLINE_CUR_UPLOAD_ABORT = `${OFFLINE_CUR_ACCOUNTS}/upload/abort`;

// Budget Management
export const BUDGET_ENDPOINT = '/cloudnova/budgets';
export const BUDGET_RESOURCE_CONFIGS = '/cloudnova/budgets/resource-configs';
// Budget Charts
export const GET_BUDGET_CHARTS = "/cloudnova/budgets/charts";
// Budget history
export const GET_BUDGET_HISTORY = "/cloudnova/budgets/history";

// Organization Budget Management
export const ORG_BUDGET_ENDPOINT = '/cloudnova/org-budgets';
export const GET_ORG_BUDGET_HISTORY = '/cloudnova/org-budgets/history';

// Organization Budget Alerts
export const ORG_BUDGET_ALERTS_ENDPOINT = '/cloudnova/org-budgets/alerts';

// Organization Budget Scheduled Reports
export const ORG_BUDGET_SCHEDULED_REPORTS_ENDPOINT = '/cloudnova/org-budgets/reports';

// Budget Group Alerts
export const BUDGET_GROUP_ALERTS_ENDPOINT = '/cloudnova/budgets/alerts';

// Budget Group Scheduled Reports
export const BUDGET_GROUP_SCHEDULED_REPORTS_ENDPOINT = '/cloudnova/budgets/reports';

// FinOps
export const GET_FINOPS_DASHBOARD = '/cloudnova/finops/dashboard';

// ARN Views (cloud-nova summary & accounts)
export const ARN_VIEWS_BASE = '/cloudnova/arn-views';
export const GET_ARN_VIEWS_SUMMARY = '/cloudnova/arn-views/summary';
export const GET_ARN_VIEWS_ACCOUNTS = '/cloudnova/arn-views/accounts';

// Remediation Hub
export const REMEDIATION_REQUESTS = '/cloudnova/remediation/requests';
export const REMEDIATION_REQUESTS_APPROVE = '/cloudnova/remediation/requests/approve';
export const REMEDIATION_REQUESTS_CANCEL = '/cloudnova/remediation/requests/cancel';
export const REMEDIATION_REQUESTS_RUN_NOW = '/cloudnova/remediation/requests/run-now';
export const REMEDIATION_REQUESTS_SCHEDULE = '/cloudnova/remediation/requests/schedule';
export const REMEDIATION_REQUESTS_INPUTS = '/cloudnova/remediation/requests/inputs';
export const REMEDIATION_REQUESTS_REFRESH = '/cloudnova/remediation/requests/refresh';
export const REMEDIATION_ERROR_CODES = '/cloudnova/remediation/error-codes';
export const REMEDIATION_REMEDIABLE_CHECKS = '/cloudnova/remediation/remediable-checks';
export const REMEDIATION_CHECK_DETAIL_BASE = '/cloudnova/remediation/checks';
export const REMEDIATION_ACTIVE_REQUESTS_BASE = '/cloudnova/remediation/accounts';
export const REMEDIATION_INVENTORY_BASE = '/cloudnova/inventory';
export const REMEDIATION_NOTIFICATION_SETTINGS = '/cloudnova/tenant/notification-settings';
export const REMEDIATION_IAM_STACK = '/cloudnova/tenant/iam-stack';

// Cognito group with auto-approve / admin-only privileges on the Remediation Hub API.
export const REMEDIATION_ADMIN_ROLE = 'Administrator';

// Azure onboarding
export const POST_AZURE_ONBOARDING_TEMPLATE = "/cloudnova/azure/onboarding/template";
export const POST_AZURE_ONBOARDING_FETCH_DETAILS = "/cloudnova/azure/onboarding/fetchdetails";
export const POST_AZURE_ONBOARDING_VERIFY = "/cloudnova/azure/onboarding/verify";

// Compliance Suppression
export const GET_SUPPRESSION_SCHEDULES = '/cloudnova/compliance-suppression/schedules';
export const GET_SUPPRESSION_FRAMEWORKS = '/cloudnova/compliance-suppression/compliance/frameworks';
export const GET_SUPPRESSION_CONTROLS = '/cloudnova/compliance-suppression/compliance/frameworks';
export const GET_SUPPRESSION_CHECKS = '/cloudnova/compliance-suppression/controls';
export const GET_SUPPRESSION_SUPPRESSIONS = '/cloudnova/compliance-suppression/schedules';
export const POST_SUPPRESSION_BULK = '/cloudnova/compliance-suppression/schedules';